var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './sds-loder.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * `sds-loader` is a web component that displays a loading indicator.
 * It provides visual feedback to users during loading processes and can be customized in terms of color and size.
 *
 * ### Attributes
 * - `color`: The color of the loader, which can be 'accent' or 'white'. Defaults to `'accent'`.
 * - `size`: The size of the loader, which can be 'lg', 'md', or 'sm'. Defaults to `'lg'`.
 *
 * @tag sds-loader
 */
let SdsLoader = (() => {
    var _SdsLoader_color_accessor_storage, _SdsLoader_size_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-loader')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _color_decorators;
    let _color_initializers = [];
    let _color_extraInitializers = [];
    let _size_decorators;
    let _size_initializers = [];
    let _size_extraInitializers = [];
    var SdsLoader = _classThis = class extends _classSuper {
        /**
         * The color of the loader.
         * This attribute allows you to customize the appearance of the loader to match the application's theme.
         *
         * Defaults to `'accent'`.
         *
         * @attr {LoaderColor} color - The loader color. Possible values are:
         * - `'accent'`
         * - `'white'`
         */
        get color() { return __classPrivateFieldGet(this, _SdsLoader_color_accessor_storage, "f"); }
        set color(value) { __classPrivateFieldSet(this, _SdsLoader_color_accessor_storage, value, "f"); }
        /**
         * The size of the loader.
         * This attribute allows you to adjust the dimensions of the loader to fit different contexts.
         *
         * Defaults to `'lg'`.
         *
         * @attr {LoaderSize} size - The loader size. Possible values are:
         * - `'lg'`
         * - `'md'`
         * - `'sm'`
         */
        get size() { return __classPrivateFieldGet(this, _SdsLoader_size_accessor_storage, "f"); }
        set size(value) { __classPrivateFieldSet(this, _SdsLoader_size_accessor_storage, value, "f"); }
        render() {
            return html `
            <div class="${this.getClasses()}" part="sds-loader" role="status" aria-live="polite">
                <svg viewBox="0 0 100 100">
                    <g transform="rotate(0 50 50)">
                        <rect
                            x="47.5"
                            y="18"
                            rx="0"
                            ry="0"
                            width="5"
                            height="16"
                            class="sds-button-loader__fill"
                        >
                            <animate
                                attributeName="opacity"
                                values="1;0"
                                keyTimes="0;1"
                                dur="1s"
                                begin="-0.875s"
                            ></animate>
                        </rect>
                    </g>
                    <g transform="rotate(45 50 50)">
                        <rect
                            x="47.5"
                            y="18"
                            rx="0"
                            ry="0"
                            width="5"
                            height="16"
                            class="sds-button-loader__fill"
                        >
                            <animate
                                attributeName="opacity"
                                values="1;0"
                                keyTimes="0;1"
                                dur="1s"
                                begin="-0.75s"
                                repeatCount="indefinite"
                            ></animate>
                        </rect>
                    </g>
                    <g transform="rotate(90 50 50)">
                        <rect
                            x="47.5"
                            y="18"
                            rx="0"
                            ry="0"
                            width="5"
                            height="16"
                            class="sds-button-loader__fill"
                        >
                            <animate
                                attributeName="opacity"
                                values="1;0"
                                keyTimes="0;1"
                                dur="1s"
                                begin="-0.625s"
                                repeatCount="indefinite"
                            ></animate>
                        </rect>
                    </g>
                    <g transform="rotate(135 50 50)">
                        <rect
                            x="47.5"
                            y="18"
                            rx="0"
                            ry="0"
                            width="5"
                            height="16"
                            class="sds-button-loader__fill"
                        >
                            <animate
                                attributeName="opacity"
                                values="1;0"
                                keyTimes="0;1"
                                dur="1s"
                                begin="-0.5s"
                                repeatCount="indefinite"
                            ></animate>
                        </rect>
                    </g>
                    <g transform="rotate(180 50 50)">
                        <rect
                            x="47.5"
                            y="18"
                            rx="0"
                            ry="0"
                            width="5"
                            height="16"
                            class="sds-button-loader__fill"
                        >
                            <animate
                                attributeName="opacity"
                                values="1;0"
                                keyTimes="0;1"
                                dur="1s"
                                begin="-0.375s"
                                repeatCount="indefinite"
                            ></animate>
                        </rect>
                    </g>
                    <g transform="rotate(225 50 50)">
                        <rect
                            x="47.5"
                            y="18"
                            rx="0"
                            ry="0"
                            width="5"
                            height="16"
                            class="sds-button-loader__fill"
                        >
                            <animate
                                attributeName="opacity"
                                values="1;0"
                                keyTimes="0;1"
                                dur="1s"
                                begin="-0.25s"
                                repeatCount="indefinite"
                            ></animate>
                        </rect>
                    </g>
                    <g transform="rotate(270 50 50)">
                        <rect
                            x="47.5"
                            y="18"
                            rx="0"
                            ry="0"
                            width="5"
                            height="16"
                            class="sds-button-loader__fill"
                        >
                            <animate
                                attributeName="opacity"
                                values="1;0"
                                keyTimes="0;1"
                                dur="1s"
                                begin="-0.125s"
                                repeatCount="indefinite"
                            ></animate>
                        </rect>
                    </g>
                    <g transform="rotate(315 50 50)">
                        <rect
                            x="47.5"
                            y="18"
                            rx="0"
                            ry="0"
                            width="5"
                            height="16"
                            class="sds-button-loader__fill"
                        >
                            <animate
                                attributeName="opacity"
                                values="1;0"
                                keyTimes="0;1"
                                dur="1s"
                                begin="0s"
                                repeatCount="indefinite"
                            ></animate>
                        </rect>
                    </g>
                </svg>
            </div>
        `;
        }
        getClasses() {
            return classMap({
                'sds-loader': true,
                'sds-loader--accent': this.color === 'accent',
                'sds-loader--white': this.color === 'white',
                'sds-loader--transparent': this.color === 'transparent',
                'sds-loader--warn': this.color === 'warn',
                'sds-loader--lg': this.size === 'lg',
                'sds-loader--md': this.size === 'md',
                'sds-loader--sm': this.size === 'sm',
            });
        }
        constructor() {
            super(...arguments);
            _SdsLoader_color_accessor_storage.set(this, __runInitializers(this, _color_initializers, 'accent'));
            _SdsLoader_size_accessor_storage.set(this, (__runInitializers(this, _color_extraInitializers), __runInitializers(this, _size_initializers, 'lg')));
            __runInitializers(this, _size_extraInitializers);
        }
    };
    _SdsLoader_color_accessor_storage = new WeakMap();
    _SdsLoader_size_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsLoader");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _color_decorators = [property({ type: String })];
        _size_decorators = [property({ type: String })];
        __esDecorate(_classThis, null, _color_decorators, { kind: "accessor", name: "color", static: false, private: false, access: { has: obj => "color" in obj, get: obj => obj.color, set: (obj, value) => { obj.color = value; } }, metadata: _metadata }, _color_initializers, _color_extraInitializers);
        __esDecorate(_classThis, null, _size_decorators, { kind: "accessor", name: "size", static: false, private: false, access: { has: obj => "size" in obj, get: obj => obj.size, set: (obj, value) => { obj.size = value; } }, metadata: _metadata }, _size_initializers, _size_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsLoader = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsLoader = _classThis;
})();
export { SdsLoader };
